import { FilterBuilder } from '../Types';

import { SuitableForValue } from 'ha/types/SearchFilters';

const suitableForBuilder: FilterBuilder = params => {
  const { suitableFor } = params;

  if (!suitableFor) {
    return '';
  }

  const queries: string[] = [];

  const students = suitableFor.includes(SuitableForValue.Students);
  const workingProfessionals = suitableFor.includes(
    SuitableForValue.WorkingProfessionals,
  );
  const couples = suitableFor.includes(SuitableForValue.Couples);

  if (students && !workingProfessionals) {
    queries.push("NOT facility_tenant_status:'working professionals only'");
  } else if (!students && workingProfessionals) {
    queries.push("NOT facility_tenant_status:'students only'");
  }

  if (couples) {
    queries.push('couplesAllowed:yes');
  }

  return queries.join(' AND ');
};

export default suitableForBuilder;
